import { Button } from "@mui/material";
import React, { useState } from "react";
import { HelpDialog } from "./HelpDialog";
import { Form } from "react-final-form";
import setFieldData from "final-form-set-field-data";
import { Text } from "../../../common/components/input/Text";
import { Checkbox } from "../../../common/components/input/Checkbox";
import { Select } from "../../../common/components/input/Select";
import { requiredNumber, requiredString, requiredUrl } from "../../util/validation";
import { CustomCookieDto } from "../../../common/service/server/dto/CookieScanDto";
import { Callout, CalloutVariant } from "../Callout";

const createCustomCookieValidation = (values) => {
  const errors = {} as any;

  requiredString(values, "name", errors);
  requiredUrl(values, "domain", errors);
  if (values.durationUnit && values.durationUnit != "session") {
    requiredNumber(values, "duration", errors);
  }

  return errors;
};

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: (request: CustomCookieDto) => Promise<void>;
};

export const CustomCookieDialog: React.FC<Props> = ({ open, onClose, onSubmit }) => {
  const [error, setError] = useState(false);
  return (
    <HelpDialog
      open={open}
      onClose={onClose}
      title={"Add Cookie"}
      className="intro-help-dialog"
      maxWidth="md"
    >
      <Form
        mutators={{ setFieldData }}
        onSubmit={async (data) => {
          setError(false);
          try {
            await onSubmit(data);
          } catch (e) {
            setError(true);
          }
        }}
        validate={createCustomCookieValidation}
        initialValues={{
          durationUnit: "session",
        }}
        render={({ handleSubmit, values, errors }) => {
          let isDisabled = Object.keys(errors).length > 0;
          if (
            !values.name ||
            !values.domain ||
            (values.durationUnit != "session" && !values.duration)
          ) {
            isDisabled = true;
          }
          return (
            <form onSubmit={handleSubmit}>
              <div className="flex-row flex--expand">
                <Text field="name" label="Name" required />
              </div>
              <div className="flex-row flex--expand">
                <Text field="domain" label="Domain" required />
              </div>
              <div className="flex-row">
                <Text
                  type="number"
                  field="duration"
                  label="Duration"
                  helperText={errors.duration ? "Required" : false}
                  disabled={!values.durationUnit || values.durationUnit == "session"}
                  required={values.durationUnit && values.durationUnit != "session"}
                  fullWidth={false}
                  className="w-128"
                />
                <Select
                  label="Unit"
                  field="durationUnit"
                  required
                  value="session"
                  fullWidth={false}
                  className="w-192"
                  options={[
                    {
                      label: "Session",
                      value: "session",
                      divider: true,
                    },
                    {
                      label: "Minutes",
                      value: "minutes",
                    },
                    {
                      label: "Hours",
                      value: "hours",
                    },
                    {
                      label: "Days",
                      value: "days",
                    },
                    {
                      label: "Months",
                      value: "months",
                    },
                    {
                      label: "Years",
                      value: "years",
                    },
                  ]}
                />
              </div>
              <div className="flex-row mt-md">
                <Checkbox field="httpOnly" label="HTTP-Only" />
                <Checkbox field="secure" label="Secure" />
              </div>
              {error && (
                <Callout className="my-md" variant={CalloutVariant.Red}>
                  Something went wrong, please try again later.
                </Callout>
              )}
              <div className="text-right mt-md">
                <Button
                  className="ml-md w-192"
                  variant="contained"
                  color="default"
                  onClick={onClose}
                >
                  Cancel
                </Button>
                <Button
                  disabled={isDisabled}
                  type="submit"
                  className="ml-md w-192"
                  variant="contained"
                  color="primary"
                >
                  Save
                </Button>
              </div>
            </form>
          );
        }}
      />
    </HelpDialog>
  );
};
